import validator from 'validator';
import i18n from "shared/i18n";

const validate = (values) => {
  const errors = {};
  const validatorOptions = {
    allow_underscores: true,
  };

  if (values.url) {
    if (values.url.includes('viber://')) {
      return {};
    }
    if (!validator.isURL(values.url, validatorOptions)) {
      errors.url = i18n.t("Please enter a valid URL or Email");
    }
  } else {
    errors.url = i18n.t("URL should not be empty");
  }

  return errors;
};

export default validate;
